import {h, Fragment} from "preact"
import Products from "./Products"
import Toolbar from "./Toolbar"
import BottomToolbar from "./BottomToolbar"
import SelectedFilters from "./SelectedFilters"
import { wrapContent } from "./ContentWrapper"
import { InfiniteScroll } from "@nosto/preact"
import Loader from "./elements/Loader"
import NoResults from "./NoResults"
import { useAppStateSelector, pick } from "@nosto/preact"
import { useEffect } from "preact/hooks"

export function SerpBody({ loading, foundProducts }) {
    const { query, response } = useAppStateSelector((state) => pick(state, "query", "response"))
    const docCount = response.products?.total ?? 0

    useEffect(() => {
        if (!loading && query && docCount !== undefined) {
            document.title = `Search: ${docCount} results found for "${query}" – Clocks and Colours`
        }
    }, [loading, query, docCount])

    if (loading) return <Loader />
    return foundProducts ? (
        <>
            <Products />
            <BottomToolbar />
        </>
    ) : (
        <NoResults />
    )
}

export function SerpBodyInfiniteScroll({ loading, foundProducts }) {
    if (!foundProducts) return loading ? <Loader /> : <NoResults />
    return (
        <>
            <InfiniteScroll>
                <Products />
            </InfiniteScroll>
        </>
    )
}

// replace with following line to enable infinite scroll
// export default wrapContent("search", SerpBodyInfiniteScroll)
export default wrapContent("search", SerpBody)
